import { CONSOLIDATION_DELIVERY_METHOD_NAME } from "@redotech/redo-model/fulfillments/consolidation";
import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";

/**
 * Whether the fulfillment group uses the consolidation delivery method.
 */
export function isConsolidationShipment(
  fulfillmentGroup: FulfillmentGroupData,
): boolean {
  const hasConsolidationDeliveryMethod = Object.values(
    fulfillmentGroup.fulfillmentOrderToDeliveryMethod ?? {},
  ).some((method) => method.name === CONSOLIDATION_DELIVERY_METHOD_NAME);

  return hasConsolidationDeliveryMethod;
}

/**
 * Determines whether the consolidation invoice download buttons (CSV and PDF)
 * should be shown for a given fulfillment group. Buttons are only visible when
 * the group is a consolidation shipment with cross-border origin and
 * destination.
 */
export function shouldShowConsolidationInvoiceButtons(
  fulfillmentGroup: FulfillmentGroupData,
): boolean {
  if (!isConsolidationShipment(fulfillmentGroup)) {
    return false;
  }

  const originCountry = fulfillmentGroup.originAddress?.countryCode;
  const destinationCountry = fulfillmentGroup.destinationAddress?.countryCode;

  const isCrossBorder =
    !!originCountry &&
    !!destinationCountry &&
    originCountry !== destinationCountry;

  return isCrossBorder;
}
